import { z } from "zod";
import { EPaymentCreationType } from "../payment-creation-types/EPaymentCreationType";
import { schemes } from "../schema-validation";
import { ETxnSpeed } from "../transaction-speeds";
import { EDisbursementMethod } from "../workers-shared";

import { ETransactionStatus } from "../odo";
import { baseEventInput } from "./baseEvent";

export const transactionEvent = baseEventInput.merge(
  z.object({
    source: z.literal("odo.webhooks.transaction"),
    payload: z
      .object({
        amount: z.number(),
        cardDetails: z
          .object({
            cardCompany: z.string().optional(),
            cardId: z.string().optional(),
            expDate: z.string().optional(),
            firstName: z.string().optional(),
            lastFour: z.string().optional(),
            lastName: z.string().optional(),
          })
          .optional(),
        bankAccountDetails: z
          .object({
            type: z.string().optional(),
            bankAccountId: z.string().optional(),
            lastFour: z.string().optional(),
          })
          .optional(),
        chargeId: schemes.uuid().optional(),
        date: z.string(),
        disbursementMethod: z.nativeEnum(EDisbursementMethod),
        external_note: z.string().optional(),
        id: z.string(),
        returnCode: z.string().optional(),
        speed: z.nativeEnum(ETxnSpeed),
        status: z.nativeEnum(ETransactionStatus),
        statusDetail: z.string().optional(),
        toDestinationId: schemes.uuid().optional(),
        toOdoId: z.string(),
        transactionEventId: schemes.uuid(),
        transactionId: schemes.uuid(),
        type: z.nativeEnum(EPaymentCreationType),
        zealPaymentId: z.string().optional(),
        payrollWorkerBankCreditSettlement: z.boolean().optional(),
        achSecCode: z.string().optional(),
        achDirection: z.enum(["credit", "debit"]).optional(),
      })
      .passthrough(),
  })
);

export type TransactionEvent = z.infer<typeof transactionEvent>;
